import { Injectable } from '@angular/core';
import { BehaviorSubject } from 'rxjs';
import { tblToken } from './../_models/app-models';

@Injectable({
  providedIn: 'root'
})
export class TokenService {
  token = new BehaviorSubject<tblToken>({} as any);
  formsToken = "formsToken"

  tempToken = new BehaviorSubject<tblToken>({} as any);
  
  sendtempToken(data) {
    this.tempToken.next(data);
  }

  gettempToken() {
    return this.tempToken.value;
  }

  sendToken(data) {
    localStorage.setItem(this.formsToken, JSON.stringify(data));
    this.token.next(data);
  };

  getSessionToken() {
    if (this.token.value?.caseNumber == null) {
      let localtoken = localStorage.getItem(this.formsToken);
      if (localtoken != null)
        this.token.next(JSON.parse(localtoken))
    };
    return this.token.value;
  };

  clearSessionToken() {
    localStorage.removeItem(this.formsToken);
    this.token.next(null)
  };

}
